'use strict';

var Marionette = require('backbone.marionette');

export default Marionette.View.extend({

  events: {
    'keyup .timezone-search': 'onSearch',
  },

  tagName: 'div',
  template: require('./templates/search.hbs'),

  onSearch: function (evt) {
    this.triggerMethod('searchTimezones', evt.currentTarget.value);
  },

});
